import client from './client';
import { unwrapData } from './response';

export const listSuppliers = async (params = {}) => {
  const response = await client.get('/inventory/suppliers', { params });
  return unwrapData(response);
};

export const createSupplier = async (payload) => {
  const response = await client.post('/inventory/suppliers', payload);
  return unwrapData(response, null);
};

export const updateSupplier = async (id, payload) => {
  const response = await client.put(`/inventory/suppliers/${id}`, payload);
  return unwrapData(response, null);
};

export const listInventoryItems = async (params = {}) => {
  const response = await client.get('/inventory/items', { params });
  return unwrapData(response);
};

export const listLowStockItems = async (params = {}) => {
  const response = await client.get('/inventory/items/low-stock', { params });
  return unwrapData(response);
};

export const createInventoryItem = async (payload) => {
  const response = await client.post('/inventory/items', payload);
  return unwrapData(response, null);
};

export const updateInventoryItem = async (id, payload) => {
  const response = await client.put(`/inventory/items/${id}`, payload);
  return unwrapData(response, null);
};

export const listPurchases = async (params = {}) => {
  const response = await client.get('/inventory/purchases', { params });
  return unwrapData(response);
};

export const getPurchase = async (id) => {
  const response = await client.get(`/inventory/purchases/${id}`);
  return unwrapData(response, null);
};

export const createPurchase = async (payload) => {
  const response = await client.post('/inventory/purchases', payload);
  return unwrapData(response, null);
};

export const listInventoryMovements = async (params = {}) => {
  const response = await client.get('/inventory/movements', { params });
  return unwrapData(response);
};

export const createInventoryMovement = async (payload) => {
  const response = await client.post('/inventory/movements', payload);
  return unwrapData(response, null);
};
